var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentItem',{attrs:{"name":_vm.name}},[_c('Dropdown',{style:('width:100%;'),attrs:{"items":_vm.language.languageFields,"selected":_vm.selectedLang},on:{"change":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }